import React, { useContext, useEffect, useRef, useState } from 'react';
import './AdyenGooglePay.less';
import { DrawerPopup } from '../../dialog-layout/drawer-popup/DrawerPopup';
import { getSafeTranslation } from '../../../helpers/localization.helper';
import { TranslationsContext } from '../../../contexts/translations-context';
import { IPaymentModel } from '../../../interfaces/adyen-payment.interface';
import Config from '../../../config';
import AdyenCheckout from '@adyen/adyen-web';
import GooglePay from '@adyen/adyen-web/dist/types/components/GooglePay';
import { AdyenHandleAction } from '../../../reducers/payment.reducer.types';

interface AdyenCardRegistrationType {
	adyenClientKey: string;
	adyenPaymentMethodsResponse: IPaymentModel;
    orderAmount: number;
    orderCurrency: string;
    handleAction: AdyenHandleAction;
    onSubmit: (state, dropin) => void;
    cancelGooglePayPopup: () => void;
    onAdditionalDetails: () => void;
}

export const AdyenGooglePay: React.FC<AdyenCardRegistrationType> = (
	{
		adyenClientKey,
		adyenPaymentMethodsResponse,
        orderAmount,
        orderCurrency,
        handleAction,
        onSubmit,
        cancelGooglePayPopup,
        onAdditionalDetails
	}
) => {

    const translations = useContext(TranslationsContext);
    const adyenGooglePayRef = useRef<HTMLDivElement>(null);
    const [dropin, setDropin] = useState<GooglePay>(null);


    const googlePayConfiguration = {
        amount: {
            value: orderAmount * 100,
            currency: orderCurrency
        },
        environment: Config.adyenEnvironment,
        buttonType: 'pay' as any
    };

    const configuration = {
        clientKey: adyenClientKey,
        environment: Config.adyenEnvironment,
        locale: Config.adyenLocale,
    };

    const checkout = new AdyenCheckout(configuration);

    useEffect(() => {
        if (!adyenClientKey || !adyenPaymentMethodsResponse) {
            return;
        }
        setDropin(checkout.create('googlepay', {
            configuration: {
                gatewayMerchantId: adyenPaymentMethodsResponse.paymentMethods[0]['configuration']['gatewayMerchantId'],
                merchantId: adyenPaymentMethodsResponse.paymentMethods[0]['configuration']['merchantId'],
            },
            ...googlePayConfiguration,
            onSubmit: onSubmit,
            onAdditionalDetails: onAdditionalDetails,
        }).mount(adyenGooglePayRef.current));
    }, [adyenClientKey, adyenPaymentMethodsResponse]);

    useEffect(() => {
        if (!handleAction || !dropin) {
			return;
		}
        dropin.handleAction(handleAction);
    }, [handleAction])

    return (
		<DrawerPopup
			title={
				getSafeTranslation('AdyenGooglePayPopup.title', translations)
			}
			onOverlayClick={cancelGooglePayPopup}
		>
            <div className="adyen-google-pay">
                <div ref={adyenGooglePayRef} />
			</div>
		</DrawerPopup>
	);
}

